'use client';
import { useState, FormEvent } from 'react';
import { signIn } from 'next-auth/react';
import Link from 'next/link';
import { useT } from '@/lib/i18n';

export default function LoginPage() {
  const t = useT();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    const res = await signIn('credentials', {
      email,
      password,
      redirect: false,
    });
    if (res?.error) {
      setError(t('auth.loginError'));
    } else {
      window.location.href = '/';
    }
  }

  async function handleGoogle() {
    await signIn('google', { callbackUrl: '/' });
  }

  return (
    <div className="min-h-full flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-8 text-center">{t('auth.login')}</h1>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm text-slate-500">{t('auth.email')}</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 text-slate-900 focus:outline-none focus:border-violet-500"
            />
          </div>
          <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between">
              <label className="text-sm text-slate-500">{t('auth.password')}</label>
              <Link href="/forgot-password" className="text-xs text-violet-400 hover:text-violet-300">
                {t('auth.forgotPassword')}
              </Link>
            </div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="bg-sky-100 border border-sky-300 rounded-lg px-3 py-2 text-slate-900 focus:outline-none focus:border-violet-500"
            />
          </div>
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            className="bg-violet-600 hover:bg-violet-500 text-white rounded-lg px-4 py-2 font-medium transition-colors"
          >
            {t('auth.login')}
          </button>
        </form>
        <button
          onClick={handleGoogle}
          className="mt-3 w-full border border-sky-300 hover:bg-sky-200 text-slate-700 rounded-lg px-4 py-2 text-sm font-medium transition-colors"
        >
          {t('auth.loginGoogle')}
        </button>
        <p className="mt-6 text-center text-sm text-slate-500">
          {t('auth.noAccount')}{' '}
          <Link href="/register" className="text-violet-400 hover:text-violet-300">
            {t('auth.register')}
          </Link>
        </p>
        <p className="mt-4 text-center text-xs text-slate-400">
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer"
            className="hover:text-slate-500 underline underline-offset-2">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
}
